<template>
	<div>
		<v-layout row wrap
			justify-end
			align-center
			v-if="id"
			class="header-booking-data">
			<v-flex xs1>
				<p>Gasto Total</p>
				<span>${{ totalExpenses | round }}</span>
			</v-flex>
			<v-flex xs1>
				<v-btn class="btn-tab" flat
					:class="{ 'active' : $route.name === 'companies-edit' }"
					@click="goTo('edit')">
					Detalle
				</v-btn>
			</v-flex>
			<v-flex xs1>
				<v-btn class="btn-tab" flat
					:class="{ 'active' : $route.name === 'companies-statistics' }"
					@click="goTo('statistics')">
					Estadística
				</v-btn>
			</v-flex>
			<v-flex xs1>
				<v-btn class="btn-tab" flat
					:class="{ 'active' : $route.name === 'companies-history' }"
					@click="goTo('history')">
					Historial
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import { round } from '@/shared/filters';

	function goTo(route) {
		this.$router.push({ name: `companies-${route}`, params: { id: this.id } });
	}

	function data() {
		return {
			totalExpenses: 0,
		};
	}

	export default {
		name: 'companies-statistics',
		data,
		filters: {
			round,
		},
		methods: {
			goTo,
		},
		props: {
			id: {
				default: 0,
				type: [Number, String],
			},
		},
	};
</script>

<style lang="scss" scoped>
	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 59px;
		width: calc(100% - 230px);

		div {
			padding-bottom: 0px !important;
			padding-top: 0px !important;
		}

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
			text-transform: uppercase;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
		}
	}

	.btn-tab {
		border-bottom: 3px solid transparent;

		&:hover,
		&.active {
			border-color: map-get($colors, default-skyblue);
		}
	}
</style>



// WEBPACK FOOTER //
// companies-statistics.vue?19f4e26a